export default __webpack_public_path__ + "static/media/registr.97ecf839.png";